import { createRouter, createWebHistory  } from 'vue-router'
import HomePage from '@/views/Home'
import Register from '@/views/register'
import Login from "@/views/login";
import FindPWD from "@/views/findPWD";
import userPage from "@/views/user/userPage";
import store from "@/store";
import userPay from "@/views/user/userPay";
import userUpgrade from "@/views/user/userUpgrade";
import userCard from "@/views/user/userCard";
import Index from "@/views/video/IndexPage";
import VideoPlay from "@/views/video/VideoPlay"
import ZBPage from "@/views/video/ZhiboPage";
import MDPage from "@/views/video/ModelPage";
import ZimuPage from "@/views/video/ZimuPage";
import NotFound from "@/views/error/NotFound";
import searchPage from "@/views/search/searchPage";
import searchResult from "@/views/search/searchResult";
import cryptoPay from "@/views/user/cryptoPay";
import WumaPage from "@/views/video/WumaPage";
import KoreaVideoPage from "@/views/video/KoreaVideoPage";
import ChinaMaker from "@/views/video/ChinaMaker";
import paySuccess from "@/components/crypto/paySuccess";
import JuRuPage from "@/views/video/JuRuPage";
import ZhifuPage from "@/views/video/ZhifuPage";
import QiBingPage from "@/views/video/QiBingPage";
import AIpage from "@/views/video/AIpage";
import TiaoJiaoPage from "@/views/video/TiaoJiaoPage";
import SiwaPage from "@/views/video/SiwaPage";
import LuanLunPage from "@/views/video/LuanLunPage";
import ChuGuiPage from "@/views/video/ChuGuiPage";
import RenQiPage from "@/views/video/RenQiPage";
import QiangJianPage from "@/views/video/QiangJianPage";
import TanHuaPage from "@/views/video/TanHuaPage";
import HuWaiPage from "@/views/video/HuWaiPage";
import NvXueshengPage from "@/views/video/NvXueshengPage";
import TongShiPage from "@/views/video/TongShiPage";
import WangBaoMenPage from "@/views/video/WangBaoMenPage";
import ChinaLunLiPage from "@/views/video/ChinaLunLiPage";
import KongJieModelPage from "@/views/video/KongJieModelPage";
import BeautyWomanPage from "@/views/video/BeautyWomanPage";
import ChinaJingPingPage from "@/views/video/ChinaJingPingPage";
import FulijiPage from "@/views/video/FulijiPage";
import ASRMpage from "@/views/video/ASRMpage";
import AnimePage from "@/views/video/AnimePage";
import AVJSpage from "@/views/video/AVJSpage";
import ONUpperPage from "@/views/video/ONUpperPage";
import ElephantMideaPage from "@/views/video/ElephantMideaPage";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta:{
      keepalive:true
    },
    children:[
      {
        path: '',
        component:Index,
        name:'index',
        meta: { keepAlive: true }
      },
      {
        path: 'v/zb',
        name:'zb',
        component:ZBPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/hgzb',
        name:'hgzb',
        component:KoreaVideoPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/md',
        name:'md',
        component:MDPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/gc',
        name:'gc',
        component:ChinaMaker,
        meta: { keepAlive: true }
      },
      {
        path: 'v/zz',
        name:'zz',
        component:ZimuPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/jr',
        name:'jr',
        component:JuRuPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/wm',
        name:'wm',
        component:WumaPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/zf',
        name:'zf',
        component:ZhifuPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/qb',
        name:'qb',
        component:QiBingPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/ai',
        name:'ai',
        component:AIpage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/tj',
        name:'tj',
        component:TiaoJiaoPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/sw',
        name:'sw',
        component:SiwaPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/ll',
        name:'ll',
        component:LuanLunPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/cg',
        name:'cg',
        component:ChuGuiPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/rq',
        name:'rq',
        component:RenQiPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/qj',
        name: 'qj',
        component:QiangJianPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/th',
        name: 'th',
        component:TanHuaPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/hw',
        name: 'hw',
        component:HuWaiPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/nxs',
        name: 'nxs',
        component:NvXueshengPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/zc',
        name: 'zc',
        component:TongShiPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/wbm',
        name: 'wbm',
        component:WangBaoMenPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/gcll',
        name: 'gcll',
        component:ChinaLunLiPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/kjmt',
        name: 'kjmt',
        component:KongJieModelPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/msf',
        name: 'msf',
        component:BeautyWomanPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/jpsp',
        name: 'jpsp',
        component:ChinaJingPingPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/fuliji',
        name: 'fuliji',
        component:FulijiPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/asmr',
        name: 'asmr',
        component:ASRMpage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/kt',
        name: 'anime',
        component:AnimePage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/avjs',
        name: 'avjs',
        component:AVJSpage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/91ds',
        name: '91ds',
        component:ONUpperPage,
        meta: { keepAlive: true }
      },
      {
        path: 'v/dxcm',
        name: 'dxcm',
        component:ElephantMideaPage,
        meta: { keepAlive: true }
      },
    ]
  },
  {
    path: '/video/play',
    name: 'VideoPlay',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: VideoPlay
  },
  {
    path: '/register',
    name: 'register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Register
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/findPWD',
    name:"findPWD",
    component: FindPWD
  },
  {
    path: '/user',
    name:"user",
    component: userPage,
    meta: {
      isToken:true
    }
  },
  {
    path: '/user/pay',
    name:"userPay",
    component: userPay,
    meta: {
      isToken:true
    }
  },
  {
    path: '/user/cryptoPay',
    name:"cryptoPay",
    component: cryptoPay,
    meta: {
      isToken:true
    }
  },
  {
    path: '/user/cryptoPaySuccess',
    name:"cryptoPaySuccess",
    component: paySuccess,
    meta: {
      isToken:true
    }
  },
  {
    path: '/user/upgrade',
    name:"userUpgrade",
    component: userUpgrade,
    meta: {
      isToken:true
    },
  },
  {
    path: '/user/buyCard',
    name:"userCard",
    component: userCard,
  },
  {
    path: '/search',
    name:"search",
    component: searchPage,
  },
  {
    path: '/search/:keyWord',
    name:"searchResult",
    component: searchResult,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // 使用保存的滚动位置
    }
    if (to.hash) {
      const savedScrollPosition = sessionStorage.getItem(to.hash);
      if (savedScrollPosition) {
        return {left:0, top:savedScrollPosition}
      }
    }
    return { left: 0, top: 0 }; // 默认滚动到顶部
  }
})

router.beforeEach((to,from, next)=> {
  cancelImageLoading()
  const isLogin = store.getters.isAuthenticated;
  const expiry = store.getters.getExpiry;
  if (/^\/(v\/[a-zA-Z0-9_-]*|)$/.test(to.path)) {
    sessionStorage.setItem('currentPath', to.path + (to.hash || ""));
  }
  if ((!isLogin ||(expiry < new Date().getTime()))&& to.meta.isToken) {
    sessionStorage.setItem('redirectPath', to.fullPath);
    return next("/login");
  }
  next()
})


function cancelImageLoading() {
  const images = document.querySelectorAll(".img"); // 选择要中断的图片
  images.forEach((img) => {
    img.src = ""; // 清空 src 以中断加载
  });
}
export default router









